<template>
  <div class="order_detail">
    <div class="order_data">
      <div class="detail_title">订单信息</div>
      <div class="detail_line pub_dashe">
        <div class="detail_left">
          <div class="pub_text">
            <div class="pub_th">订单号:</div>
            <div>{{ order_detail.orderCode }}</div>
          </div>
          <div class="pub_text">
            <div class="pub_th">下单时间:</div>
            <div>
              {{
                  $api
                    .moment(order_detail.createTime)
                    .format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </div>
        </div>
        <div class="detail_right">
          <div class="pub_text">
            <div class="pub_th">订单状态:</div>
            <div style="color: #0083ff; font-size: 23px; font-weight: 700">
              {{ status_packing(order_detail.status) }}
            </div>
            <div style="display: flex; align-items: center" v-if="
              order_detail.status == 'PART_SEND_GOODS' ||
              order_detail.status == 'WAIT_SEND_GOODS'
            ">
              <el-button size="small" @click="send_sub(order_detail.id)">发货</el-button>
            </div>
            <div v-if="order_detail.status == 'WAIT_ORDER_RECEIVING'">
              <el-button size="small" type="primary" @click="recevie(order_detail.id)">接单</el-button>
            </div>
          </div>
          <div class="pub_text">
            <div class="pub_th">买家:</div>
            <div>{{ order_detail.buyerNickName }}</div>
          </div>
        </div>
      </div>
      <div class="detail_line pub_dashe">
        <div class="detail_left">
          <div class="pub_text">
            <div class="pub_th">收货人:</div>
            <div>{{ order_detail.receiverName }}</div>
          </div>
          <div class="pub_text">
            <div class="pub_th">收货地址:</div>
            <div>{{ order_detail.receiverAddress }}</div>
          </div>
        </div>
        <div class="detail_right">
          <div class="pub_text">
            <div class="pub_th">收货人手机号:</div>
            <div>{{ order_detail.receiverMobile }}</div>
          </div>
        </div>
      </div>
      <div class="detail_line">
        <div class="detail_left">
          <div class="pub_text">
            <div class="pub_th">发货时间:</div>
            <div>
              {{
                  $api
                    .moment(order_detail.deliveryTime)
                    .format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </div>
          <div class="pub_text" style="display: flex; cursor: pointer">
            <div class="pub_th">物流公司:</div>
            <div v-if="order_detail.length != 0">
              <div v-for="item in order_detail.waybillInfo" :key="item.waybillCode">
                <el-popover placement="right" width="400" trigger="click" @show="getLogicsData(item)">
                  <!-- <iframe style="width:100%;height:350px" :src="item.src"></iframe> -->
                  <div v-if="activities.length!=0">
                    <el-timeline>
                    <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
                      :type="activity.type" :color="activity.color" :size="activity.size"
                      :timestamp="activity.timestamp">
                      {{ activity.content }}
                    </el-timeline-item>
                  </el-timeline>
                  </div>
                  <div v-else>
                    <el-empty :image-size="200" description="暂无物流信息"></el-empty>
                  </div>
                  <div slot="reference">
                    <span>{{ item.expressCompany }} </span>
                    <span>{{ item.waybillCode }}</span>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div class="pub_text">
            <div class="pub_th">订单备注:</div>
            <div style="max-width: 83%;max-height: 40px;overflow: hidden;overflow-y: auto;">
              {{ order_detail.memo }}
            </div>
          </div>
        </div>
        <div class="detail_right">
          <div class="pub_text">
            <div class="pub_th">签收时间:</div>
            <div>
              {{
                  $api.moment(order_detail.signTime).format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="goods_table">
      <el-table :header-cell-style="{
        background: '#eeeeee',
        padding: '4px',
        color: '#606266',
      }" :data="order_detail.skuList" border style="width: 99.8%">
        <el-table-column align="center" label="商品">
          <template slot-scope="scope">
            <div class="table_img_box">
              <div class="demo-image__preview">
                <el-image :z-index="99999" style="width: 80px; height: 80px" :src="scope.row.skuImage"
                  :preview-src-list="src_list(scope.row.skuImage)">
                </el-image>
              </div>
              <div class="img_text">{{ scope.row.goodsName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="skuCode" label="Sku编码" width="180">
        </el-table-column>
        <el-table-column align="center" prop="skuName" width="180" label="规格">
        </el-table-column>
        <el-table-column align="center" prop="quantity" width="180" label="数量">
        </el-table-column>
        <el-table-column align="center" prop="costPrice" width="180" label="单价">
        </el-table-column>
        <el-table-column align="center" prop="costTotalFee" width="180" label="小计">
        </el-table-column>
      </el-table>
      <div style="text-align: right; padding: 20px 20px 15px 0">
        <span>实付款:</span>
        <span style="font-size: 22px; font-weight: 600">{{
            order_detail.skuTotalCost
        }}</span>
      </div>
    </div>
    <sendGoods @changeshow="change" :orderType="orderType" :dialogShow="dialogShow" :orderId="orderId"></sendGoods>
  </div>
</template>
<script>
import { get_detail, recevie_order,getWLData } from "@/request/api/order";
import sendGoods from "./components/sendGoods.vue";
export default {
  components: {
    sendGoods,
  },
  data() {
    return {
      activities: [],
      order_detail: {},
      dialogShow: false,
      orderId: "",
      orderType: "general",
    };
  },
  created() {
    console.log(this.$route.params)
    get_detail(this.$route.params).then((res) => {
      console.log('zheli', res)
      res.data.waybillInfo = JSON.parse(res.data.waybillInfo)
      res.data.waybillInfo.forEach(item => {
        item.src = 'https://m.kuaidi100.com/result.jsp?nu=' + item.waybillCode
      });
      console.log(res.data);
      this.order_detail = res.data;
    });
  },
  methods: {
    getLogicsData(data){
      let obj={
        nu:data.waybillCode,
        comName:data.expressCompany
      }
      getWLData(obj).then(res=>{
        console.log(res.data.error)
        if(!res.data.error&&res.data.details.length!=0){
          res.data.details[0].color = '#0bbd87'
          res.data.details.forEach(item=>{
            this.$set(item,'timestamp',item.time)
            this.$set(item,'content',item.context)
          })
          this.activities = res.data.details
        }else{
          this.activities = []
        }
        
        
        console.log(res)
      })
    },
    // popoverShow(e){
    //   console.log(e)
    // },
    recevie(e) {
      this.$confirm("确认接单吗？")
        .then(() => {
          console.log(e);
          recevie_order(e).then((res) => {
            if (res.code == 0) {
              this.$api.s_msg(res.msg);
              this.$parent.$refs.status_bar.get_order(
                this.$parent.page_order_data
              );
            } else {
              this.$api.e_msg(res.msg);
            }
            console.log(res);
          });
        })
        .catch(() => {
          console.log("取消");
        });

      // return
    },
    change(e) {
      console.log(e);
      this.dialogShow = e;
    },
    send_sub(e) {
      console.log(e);
      this.orderId = e;
      this.dialogShow = true;
    },
    //   图片预览
    src_list(e) {
      return e.split(",");
    },
    // 封装订单状态
    status_packing(data) {
      switch (data) {
        case "WAIT_AUDIT":
          return "待审核";
        case "WAIT_QUOTE":
          return "待报价";
        case "WAITING":
          return "等待结果";
        case "OUT":
          return "未中标";
        case "WAIT_PAY":
          return "待支付";
        case "WAIT_PAY_CONFIRM":
          return "支付待确认";
        case "WAIT_SEND_GOODS":
          return "待发货";
        case "PART_SEND_GOODS":
          return "部分发货";
        case "WAIT_CONFIRM_SIGNED":
          return "待签收";
        case "FINISH":
          return "完成";
        case "CLOSED":
          return "关闭";
        case "CANCEL":
          return "取消";
        case "WAIT_SEND_ORDER":
          return "待派单";
        case "WAIT_ORDER_RECEIVING":
          return "待接单";
        default:
          return "未知订单"; // 如果没有与表达式相同的值，则执行该代码
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pub_text /deep/ .el-button {
  background-color: #44abf7;
  color: #ffffff;
  border: 0;
  margin-left: 10px;
}

/deep/ .el-button--small {
  padding: 5px 12px;
}

.order_detail {
  border-top: 1px solid #eeeeee;
  background-color: #fff;
  // height: 100%;

  .order_data {
    font-size: 15px;
    box-sizing: border-box;
    // height: 45%;
    overflow: hidden;
    overflow-y: auto;
    color: #515151;
    margin: 20px;
    border: 1px solid #d8d8d8;

    .detail_title {
      font-size: 16px;
      font-weight: 500;
      background-color: #eeeeee;
      padding: 2px 0 2px 20px;
      box-sizing: border-box;
    }

    .pub_dashe {
      border-bottom: 1px dashed #eeeeee;
      padding-bottom: 10px;
      box-sizing: border-box;
    }

    .pub_text {
      padding: 3px 0;
      box-sizing: border-box;
      display: flex;

      .pub_th {
        width: 100px;
        display: flex;
        align-items: center;
      }
    }

    .detail_line {
      display: flex;
      box-sizing: border-box;
      padding: 10px 20px;
      width: 100%;
      // padding: 10px 0 10px 20px;
    }

    .detail_left {
      // width: 75%;
      flex: 2;
    }

    .detail_right {
      flex: 1;
      text-align: left;
    }
  }

  .goods_table {
    // height: 50%;
    box-sizing: border-box;
    margin: 0 20px;
    overflow: hidden;
    overflow-y: auto;

    .table_img_box {
      display: flex;
      justify-content: center;
      align-items: center;

      .img_text {
        padding-left: 10px;
      }
    }
  }
}
</style>